class ProductImageZoom {
  constructor(container) {
    this.container = container;
    this.image = container.querySelector('.product-zoom-image');

    if (!this.image) return;

    this.handlePointerEnter = this.handlePointerEnter.bind(this);
    this.handlePointerMove = this.handlePointerMove.bind(this);
    this.handlePointerLeave = this.handlePointerLeave.bind(this);

    this.bindEvents();
  }

  bindEvents() {
    this.container.addEventListener(
      'pointerenter',
      this.handlePointerEnter
    );

    this.container.addEventListener(
      'pointermove',
      this.handlePointerMove
    );

    this.container.addEventListener(
      'pointerleave',
      this.handlePointerLeave
    );
  }

  isDesktopPointer(event) {
    return (
      window.matchMedia('(min-width: 990px)').matches &&
      event.pointerType !== 'touch'
    );
  }

  // handlePointerEnter(event) {
  //   if (!this.isDesktopPointer(event)) return;

  //   this.container.classList.add('is-zoomed');
  // }

  handlePointerEnter(event) {
    if (!this.isDesktopPointer(event)) return;

    const image = this.container.querySelector('.product-zoom-image');
    const zoomImage = this.container.dataset.zoomImage;

    if (image && zoomImage) {
      image.dataset.originalSrc = image.src;
      image.dataset.originalSrcset = image.srcset;

      image.removeAttribute('srcset');
      image.src = zoomImage;
    }

    this.container.classList.add('is-zoomed');
  }

  handlePointerMove(event) {
    if (!this.isDesktopPointer(event)) return;

    const bounds = this.container.getBoundingClientRect();

    const x = ((event.clientX - bounds.left) / bounds.width) * 100;
    const y = ((event.clientY - bounds.top) / bounds.height) * 100;

    const clampedX = Math.min(100, Math.max(0, x));
    const clampedY = Math.min(100, Math.max(0, y));

    this.image.style.transformOrigin =
      `${clampedX}% ${clampedY}%`;
  }

  // handlePointerLeave() {
  //   this.container.classList.remove('is-zoomed');
  //   this.image.style.transformOrigin = '50% 50%';
  // }

  handlePointerLeave() {
    const image = this.container.querySelector('.product-zoom-image');

    if (image && image.dataset.originalSrc) {
      image.src = image.dataset.originalSrc;

      if (image.dataset.originalSrcset) {
        image.srcset = image.dataset.originalSrcset;
      }

      delete image.dataset.originalSrc;
      delete image.dataset.originalSrcset;
    }

    this.container.classList.remove('is-zoomed');
  }
}

function initialiseProductImageZoom(root = document) {
  root.querySelectorAll('[data-image-zoom]').forEach((container) => {
    if (container.dataset.zoomInitialised === 'true') return;

    container.dataset.zoomInitialised = 'true';
    new ProductImageZoom(container);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initialiseProductImageZoom();
});

document.addEventListener('shopify:section:load', (event) => {
  initialiseProductImageZoom(event.target);
});